function CastFallbackIcon({ className }) {
   return (
      <svg
         className={className}
         viewBox="0 0 24 24"
         fill="currentColor"
         aria-hidden="true"
      >
         <path d="M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z" />
      </svg>
   );
}

export default CastFallbackIcon;
